module.exports = __webpack_public_path__ + "img/balkonverkleidung02.3522af08.webp";